import { Injectable } from '@angular/core';
import { AuthService } from '../../../../core';
import { Arquivo } from '../arquivo';

/** Service que valida os acessos e execuções de funcionalidades dos arquivos */
@Injectable({
    providedIn: 'root'
})
export class ArquivoAuthGuardService {

    constructor(private authService: AuthService) { }

    /** Verifica se pode abrir o arquivo */
    canOpen(id: number): boolean {
        return id > 0;
    }

    /** Verifica se pode fazer o download do arquivo */
    canDownload(id: number): boolean {
        return id > 0;
    }

    /** Verifica se pode excluir um arquivo */
    canDelete(id: number, idUsuarioCreated: number ): boolean {
        if (!id) {
            return false;
        }

        // Somente o usuário que criou o arquivo ou um admin
        return idUsuarioCreated == this.authService.getIdUsuario() || this.authService.isAdministrador();
    }
}
